import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopy from '@/views/assistant/operationsManagement/stroageRule/components/addEditCopy.vue';

var OperationsManagementStorageRuleEditPage = function (_super) {
  __extends(OperationsManagementStorageRuleEditPage, _super);

  function OperationsManagementStorageRuleEditPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  OperationsManagementStorageRuleEditPage = __decorate([Component({
    components: {
      AddEditCopy: AddEditCopy
    }
  })], OperationsManagementStorageRuleEditPage);
  return OperationsManagementStorageRuleEditPage;
}(Vue);

export default OperationsManagementStorageRuleEditPage;